import formatDateHelper from "@/Utils/formatDateHelper";

// Pass a date and get the last second of the same day.
// This is useful for filtering values for a particular date
export const endOfDate = (date: Date): string => formatDateHelper.format(date, "YYYY-MM-DDT23:59:59");
export const endOfStringDate = (date: string): string => formatDateHelper.format(date, "YYYY-MM-DDT23:59:59");
